export const soportePreguntasReportesRoutes = (apiBase) => ({
  soportePost: `${apiBase}/soporte`,
  pdfTemplates: (codigo) => `${apiBase}/pdftemplates?codigo=${codigo}`,
  getQuestions: (idPregunta, idSubg) => `${apiBase}/obtenerPreguntaxIdpreguntaSub?idpregunta=${idPregunta}&idSubg=${idSubg}`,
  saveQuestions: `${apiBase}/guardarPregunta`,
  deleteQuestions: `${apiBase}/eliminarPregunta`,
  getExcludedQuestionsBySubgroup: (grupo, subgrupo) => `${apiBase}/preguntas-excluidas-subgrupo?grupo=${grupo}&subgrupo=${subgrupo}`,
  getAvailableExcludedQuestions: `${apiBase}/preguntas-excluidas-subgrupo/preguntas-disponibles`,
  saveExcludedQuestionsBySubgroup: `${apiBase}/preguntas-excluidas-subgrupo/guardar`,
  deleteExcludedQuestionBySubgroup: `${apiBase}/preguntas-excluidas-subgrupo/eliminar`,
  getExcludedActivitiesBySubgroup: (grupo, subgrupo) => `${apiBase}/actividades-excluidas-subgrupo?grupo=${grupo}&subgrupo=${subgrupo}`,
  getAvailableExcludedActivities: `${apiBase}/actividades-excluidas-subgrupo/actividades-disponibles`,
  saveExcludedActivitiesBySubgroup: `${apiBase}/actividades-excluidas-subgrupo/guardar`,
  deleteExcludedActivityBySubgroup: `${apiBase}/actividades-excluidas-subgrupo/eliminar`,
  getHelpQuestions: (idPregunta) => `${apiBase}/obtenerAyudaPreguntaxIdpregunta?idpregunta=${idPregunta}`,
  saveHelpQuestions: `${apiBase}/guardarAyudaPregunta`,
  getReports: `${apiBase}/reporte`,
  getComponentReport: (idReporte) => `${apiBase}/getComplementosReporte?idReporte=${idReporte}`,
  postReport: `${apiBase}/reporte/ejecutar`,
  postOptionsDPReport: `${apiBase}/reporte/obtenerOpcionesDependientes`,
  reporte202: `${apiBase}/reporte/202`,
  reporte2175: `${apiBase}/reporte/2175`,
});
